module.exports = __webpack_public_path__ + "img/thesign.12a81524.jpeg";